import { PrimaryButton, Table, Tooltip } from '@shape-ds/components';
import {
  handleOilAnalysisSave,
  ExtendedOilData,
  getSelectedOilCells,
} from 'components/Evidences/Helpers/helper';
import './AttachOilAnalysisTable.scss';
import { useTranslation } from 'react-i18next';
import { useOilAnalysisColumns } from './useOilAnalysisColumns';
import { NoData } from 'pages/Asset/tabs/Cases/components/NoData/NoData';
import { AddCircleOutlineOutlined } from '@mui/icons-material';
import { useOilAnalysisMutation } from 'queries/externalReferences/queries';

type OilAnalysisData = {
  period: string;
  filteredData: ExtendedOilData[];
  hasAnySelectedCells: boolean;
  handleCellSelectionChange: (params: {
    description: string;
    columnKey: string;
    value: boolean;
  }) => void;
  handlePeriodChange: (value: string) => void;
  clearSelections: () => void;
  isLoading: boolean;
};

export const AttachOilAnalysisTable = ({
  assetId,
  oilAnalysisData,
}: {
  assetId: string;
  oilAnalysisData: OilAnalysisData;
}) => {
  const { t } = useTranslation();

  const { filteredData, hasAnySelectedCells, handleCellSelectionChange, isLoading } =
    oilAnalysisData;

  const oilAnalysisMutation = useOilAnalysisMutation();

  const { columns } = useOilAnalysisColumns({
    data: filteredData,
    handleCellSelectionChange,
  });

  const handleSaveClick = () => {
    if (getSelectedOilCells(filteredData).length > 0) {
      handleOilAnalysisSave(getSelectedOilCells(filteredData), assetId, oilAnalysisMutation.mutate);
    }
  };

  return (
    <div className="attach-oil-analysis-table-container">
      {filteredData.length > 0 ? (
        <>
          <Table<ExtendedOilData>
            className="attach-oil-analysis-table"
            data={filteredData}
            columns={columns}
            style={{
              minHeight: '220px',
              minWidth: '605px',
              maxHeight: '43.5vh',
              maxWidth: '66.5vw',
            }}
          />

          <Tooltip
            title={`${
              !hasAnySelectedCells ? t('monitoring:tables.messages.selectAtLeastOne') : ''
            }`}
          >
            <PrimaryButton
              onClick={handleSaveClick}
              startIcon={<AddCircleOutlineOutlined />}
              disabled={!hasAnySelectedCells || oilAnalysisMutation.isLoading}
              className={`${
                !hasAnySelectedCells ? 'attach-btn-disabled' : ''
              } attach-oil-analysis-btn`}
            >
              {oilAnalysisMutation.isLoading
                ? t('monitoring:tables.messages.saving')
                : t('monitoring:tables.messages.addEvidence')}
            </PrimaryButton>
          </Tooltip>
        </>
      ) : (
        <NoData
          i18nKey="monitoring:tables:messages.no_data.OIL_ANALYSIS"
          icon={null}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};
